
import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { Meta } from '@core/Meta';
import { useTitle } from '@context/Utils/Title';
import { MpsAutoTopupOverview } from './MpsAutoTopupOverview';
import { MpsAutoTopupDetails } from './MpsAutoTopupDetails';
import { MpsAutoTopupAmount } from './MpsAutoTopupAmount';
import { MpsAutoTopupPaymentMethod } from './MpsAutoTopupPaymentMethod';

export function ActivationStep8() {
  // Context
  const { step8SubStep, setStep8SubStep, setShowActivationFooter, setShowActivationHeader } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();

  // META: page titles
  const { globalPageTitle } = getGlobalMetaTitles();
  const activationRegTopUpPageTitle = tA11yTranslate('ek_global_meta_title_reg_top_up').content;

  // Simplified - same title for all substeps
  const getPageTitle = () => `${globalPageTitle} - ${activationRegTopUpPageTitle}`;

  useEffect(() => {
    const pageTitle = getPageTitle();
    announceTitle(pageTitle);
  }, [step8SubStep, announceTitle]); // Re-run when substep changes

  // Hooks
  useEffect(() => {
    // reset substep handling
    setStep8SubStep(0);
  }, []);

  useEffect(() => {
    // Show header/footer by default for all MPS auto-topup substeps
    setShowActivationFooter(true);
    // Hide header for substep 1 (MpsAutoTopupDetails) - background image replaces it
    setShowActivationHeader(step8SubStep !== 1);
  }, [step8SubStep]);

  const renderStep8SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <MpsAutoTopupOverview />;
      case 1:
        return <MpsAutoTopupDetails />;
      case 2:
        return <MpsAutoTopupAmount />;
      case 3:
        return <MpsAutoTopupPaymentMethod />;
      // case 4 is handled by PaymentCallbackHandler at global route level, so it won't be rendered here
      default:
        return <MpsAutoTopupOverview />;
    }
  };

  return (
    <>
      <Meta title={getPageTitle()} key={`meta-step-${step8SubStep}`} />
      {renderStep8SubSteps(step8SubStep)}
    </>
  );
}

export default ActivationStep8;